import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
} from '@angular/core';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { FormControl } from '@angular/forms';
import { toLocalAPIDate } from 'src/app/utils/date';
import { FilterOptions } from 'src/app/shared/models/filters/filter-options';

@Component({
  selector: 'app-date-tab-selector',
  templateUrl: './date-tab-selector.component.html',
  styleUrls: ['./date-tab-selector.component.scss'],
})
/**
 * Date selector for timeline organism
 */
export class DateTabSelectorComponent implements OnInit, OnChanges {
  @Output() selectFilterClick = new EventEmitter<FilterOptions>();
  @Input() businessRegisterDate?: Date;
  @Input() filters!: FilterOptions;
  yearsOptions: number[] = [];
  yearControl = new FormControl();
  selectedMonthIndex: number = new Date().getMonth();

  months = [
    'JAN',
    'FEB',
    'MAR',
    'APR',
    'MAY',
    'JUN',
    'JUL',
    'AUG',
    'SEP',
    'OCT',
    'NOV',
    'DEC',
  ];

  /**
   * on init
   */
  ngOnInit() {
    this.yearControl.valueChanges.subscribe(() => {
      this.emitDateRange();
    });
  }

  /**
   * on changes
   */
  ngOnChanges() {
    if (this.businessRegisterDate && this.yearsOptions.length === 0) {
      this.yearsOptions = this.generateYearFilter();
      const currentYear = new Date().getFullYear();
      this.yearControl.setValue(currentYear, { emitEvent: false });
      this.emitDateRange();
    }
  }

  /**
   * Set tab filter
   * @param {MatTabChangeEvent} event
   */
  setTabFilter(event: MatTabChangeEvent) {
    this.selectedMonthIndex = event.index;
    this.emitDateRange();
  }

  /**
   * Method to emit a date range filter
   */
  private emitDateRange() {
    const year = this.yearControl.value;
    const month = this.selectedMonthIndex;

    const startDate = new Date(year, month, 1);
    const endDate = new Date(year, month + 1, 0, 23, 59, 59);

    this.filters.dateRange = {
      startDate: toLocalAPIDate(startDate),
      endDate: toLocalAPIDate(endDate),
    };

    this.selectFilterClick.emit(this.filters);
  }

  /**
   * Get list of year
   * @return {number[]}
   */
  generateYearFilter(): number[] {
    if (!this.businessRegisterDate) {
      return [];
    }
    const startYear = new Date(this.businessRegisterDate).getUTCFullYear();
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = startYear; year <= currentYear; year++) {
      years.push(year);
    }

    return years.reverse();
  }
}
